// @flow
import React from 'react';
import { SP_USER_COMMIT_DETAILS_CONFIG_MAP } from '@streaming-projects/user-commit-details/config';
import { BACKEND_FIELDNAMES } from '@streaming-projects/enums';
import { BooleanSelectField } from '@src/formik-utils/FormFields';

export const SPUserCommitCommittedCapacityContainer = () => {
  const { COMMITTED_CAPACITY } = BACKEND_FIELDNAMES;

  const { backendFieldName, displayName } =
    SP_USER_COMMIT_DETAILS_CONFIG_MAP.get(COMMITTED_CAPACITY);

  return <BooleanSelectField fieldDisplayName={displayName} fieldName={backendFieldName} />;
};
